import React, { useState } from "react";

const REASONS = {
  in: [
    { value: "fond_caisse", label: "Fond de caisse" },
    { value: "apport_banque", label: "Apport banque" },
    { value: "autre", label: "Autre" }
  ],
  out: [
    { value: "depot_banque", label: "Dépôt banque" },
    { value: "petty_cash", label: "Petty cash (achats divers)" },
    { value: "autre", label: "Autre" }
  ]
};

const CashMovementModal = ({ show, type, isAdmin, onClose, onConfirm }) => {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [showPinCode, setShowPinCode] = useState(false);
  const [pinCode, setPinCode] = useState("");

  if (!show) return null;

  const isOut = type === "out";
  const title = isOut ? "RETRAIT DE CAISSE" : "APPORTER EN CAISSE";
  const themeColor = isOut ? "#ef4444" : "#10b981";

  // Build dynamic reason list
  let availableReasons = REASONS[type];
  if (isOut && isAdmin) {
    // Only admins see the Prélèvement option
    availableReasons = [
      ...availableReasons,
      { value: "prelevement_exploitant", label: "Prélèvement personnel (Exploitant)" }
    ];
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0 || !reason) return;
    
    if (reason === "prelevement_exploitant" && !showPinCode) {
      setShowPinCode(true);
      return;
    }
    
    // In a real app, you would verify the PIN against the user profile here.
    // We bypass real verification for the UX demonstration, assuming they are already logged in as admin.
    onConfirm({
      type,
      amount: parseFloat(amount),
      reason,
      note
    });
    
    // Reset state
    setAmount("");
    setReason("");
    setNote("");
    setShowPinCode(false);
    setPinCode("");
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow-lg border-0" style={{ backgroundColor: "#1f2937", color: "white", borderRadius: "12px" }}>
          
          <div className="modal-header border-bottom-0 pt-4 pb-0">
            <h5 className="modal-title fw-bold" style={{ color: themeColor }}>
              {isOut ? <i className="bi bi-box-arrow-up me-2"></i> : <i className="bi bi-box-arrow-in-down me-2"></i>}
              {title}
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          
          <div className="modal-body">
            {!showPinCode ? (
              <form onSubmit={handleSubmit} id="cashMovementForm">
                <div className="mb-4">
                  <label className="form-label small fw-bold text-light opacity-75">MONTANT (EUR)</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    min="0.01" 
                    className="form-control form-control-lg bg-dark text-white text-center fw-bold fs-3 border-0" 
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label small fw-bold text-light opacity-75">MOTIF DU MOUVEMENT</label>
                  <select 
                    className="form-select bg-dark text-white border-secondary"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    required
                  >
                    <option value="">-- Sélectionner un motif --</option>
                    {availableReasons.map(r => (
                      <option key={r.value} value={r.value}>{r.label}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label small fw-bold text-light opacity-75">NOTE / OBSERVATION (Optionnel)</label>
                  <textarea 
                    className="form-control bg-dark text-white border-secondary" 
                    rows="2"
                    placeholder="Détails supplémentaires..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  ></textarea>
                </div>
              </form>
            ) : (
              <div className="text-center py-3">
                <h6 className="text-warning mb-3">
                  <i className="bi bi-shield-lock-fill fs-4 d-block mb-2"></i>
                  Confirmation Administrateur Requise
                </h6>
                <p className="small text-muted mb-4">Pour enregistrer un prélèvement personnel, veuillez saisir votre code PIN.</p>
                <input 
                  type="password" 
                  className="form-control form-control-lg bg-dark text-white text-center fw-bold fs-3 border-secondary mx-auto w-50 mb-3" 
                  maxLength="4"
                  placeholder="****"
                  value={pinCode}
                  onChange={(e) => setPinCode(e.target.value)}
                  autoFocus
                />
              </div>
            )}
          </div>
          
          <div className="modal-footer border-top-0 pt-0 pb-4 d-flex justify-content-between gap-2 px-4">
            <button type="button" className="btn btn-secondary fw-bold px-4 flex-grow-1" onClick={onClose}>
              ANNULER
            </button>
            <button 
              type="submit" 
              form="cashMovementForm"
              className="btn fw-bold px-4 flex-grow-1" 
              style={{ backgroundColor: themeColor, color: "white" }}
              disabled={!amount || !reason || (showPinCode && pinCode.length < 4)}
              onClick={showPinCode ? handleSubmit : undefined}
            >
              {showPinCode ? "CONFIRMER" : "VALIDER"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CashMovementModal;

